import { render, staticRenderFns } from "./SelfcheckLoader.vue?vue&type=template&id=253a5c73&scoped=true&"
var script = {}
import style0 from "./SelfcheckLoader.vue?vue&type=style&index=0&id=253a5c73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253a5c73",
  null
  
)

export default component.exports